export const RESILIENCE_LAST_PUSH_SUCCESS_AT_KEY = 'esan:resilience:last-push-success-at' as const;
export const RESILIENCE_LAST_EXPORT_AT_KEY = 'esan:resilience:last-export-at' as const;

function readIso(key: string): string | null {
  try {
    const raw = globalThis.localStorage?.getItem(key);
    return raw?.trim() || null;
  } catch {
    return null;
  }
}

function writeIso(key: string, iso: string): void {
  try {
    globalThis.localStorage?.setItem(key, iso);
  } catch {
    /* ignore */
  }
}

export function readResilienceLastPushSuccessAt(): string | null {
  return readIso(RESILIENCE_LAST_PUSH_SUCCESS_AT_KEY);
}

export function readResilienceLastExportAt(): string | null {
  return readIso(RESILIENCE_LAST_EXPORT_AT_KEY);
}

export function recordResiliencePushSuccess(at = new Date()): void {
  writeIso(RESILIENCE_LAST_PUSH_SUCCESS_AT_KEY, at.toISOString());
}

export function recordResilienceExport(at = new Date()): void {
  writeIso(RESILIENCE_LAST_EXPORT_AT_KEY, at.toISOString());
}
